// Shared onboarding_step -> route map, single source of truth for
// GuestLayout, DashboardLayout, and OnboardingLayout redirect logic.
export const ONBOARDING_ROUTES = {
  CHOOSE_INTEGRATION: '/choose-integration',
  SETUP_INTEGRATION: '/whatsapp-setup',
  ACTIVATE_INTEGRATION: '/whatsapp-activation',
  PAYMENT_PENDING: '/whatsapp-activated',
  COMPLETED: '/dashboard',
};
